/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Legal_PrivacyInputs */

const en_auth_legal_privacy = /** @type {(inputs: Auth_Legal_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Auth_Legal_PrivacyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth_legal_privacy = /** @type {((inputs?: Auth_Legal_PrivacyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Legal_PrivacyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_legal_privacy(inputs)
});